import { computed, inject, type InjectionKey } from 'vue'

/** Q-07 is open. Applications may supply their existing preference store; otherwise the URL owns the size. */
export interface ListPageSizeStore {
  read(): unknown
  write(size: number): void
}
export const listPageSizeStoreKey: InjectionKey<ListPageSizeStore> = Symbol('list-page-size-store')
export const standardPageSizes = [25, 50, 100] as const

export function allowedPageSize<T extends number>(value: unknown, options: readonly T[], fallback: T): T {
  const number = typeof value === 'number' || typeof value === 'string' ? Number(value) : NaN
  return options.find(size => size === number) ?? fallback
}

/** Read the same injectable preference before the first API request, not after the pager mounts. */
export function useListPageSize<T extends number>(urlSize: () => unknown, options: readonly T[], fallback: T) {
  const store = inject(listPageSizeStoreKey, undefined)
  return computed(() => allowedPageSize(urlSize() ?? store?.read(), options, fallback))
}
